import { useSearchParams } from "react-router-dom";
import style from "./BalancePage.module.scss";
import { ExplanationBlock, ReplenishForm, TableHistory, TabsNavigate } from "./components";

export function BalancePage() {
    const [queryParams] = useSearchParams();

    return (
        <main className={style.page}>
            <TabsNavigate />
            {
                queryParams.get("tab") === "replenish"
                    ? <>
                        <ReplenishForm />
                        <ExplanationBlock />
                    </>
                    : null
            }
            {
                queryParams.get("tab") === "history"
                    ? <TableHistory />
                    : null
            }
        </main>
    )
}